import type { DrawResult } from './reward-types'

/** The 12th-anniversary tree gets a different artwork variant in the Rive
 *  cakebox; every other tree uses the default. */
const SPECIAL_TREE_GID = 169

export type RewardPresentation =
  | {
      isDuplicate: false
      treeGid: number
      subtitleKind: 'tree-name'
      numRewardType: 1 | 2
    }
  | {
      isDuplicate: true
      treeGid: number
      subtitleKind: 'stamps'
      stampQuantity: number
      numRewardType: 1 | 2
    }

export function deriveRewardPresentation(draw: DrawResult): RewardPresentation {
  const { final_prize: final, original_prize: original } = draw
  const isDuplicate = original.type !== final.type

  if (isDuplicate) {
    return {
      isDuplicate: true,
      treeGid: original.value,
      subtitleKind: 'stamps',
      stampQuantity: final.quantity ?? 1,
      numRewardType: 1,
    }
  }

  return {
    isDuplicate: false,
    treeGid: final.value,
    subtitleKind: 'tree-name',
    numRewardType: final.value === SPECIAL_TREE_GID ? 2 : 1,
  }
}
